import { Frame, Loading } from '@shopify/polaris';
import { useHistory } from 'react-router-dom';
import { useCallback, useState } from 'react';
import Form from './Form';
import Api from '../../helpers/api';
import formatErrors from '../../helpers/format_errors';

export default () => {
    const history = useHistory();
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const handleSubmit = useCallback((data) => {
        setSaving(true);

        Api.createDiscountCode(data)
            .then(response => {
                history.push(`/discount-codes/${response.data.data.id}/edit?created=1`);
            })
            .catch(error => {
                if ( error?.response?.status == 422 ) {
                    setErrors(formatErrors( error.response.data ));
                } else {
                    throw error;
                }

                setSaving(false);
            });
    }, []);

    return (
        <Frame>
            {saving && <Loading />}
            <Form handleSubmit={handleSubmit} saving={saving} errors={errors} />
        </Frame>
    )
}
